import React from 'react';
import { useHistory } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { ChevronRight } from 'lucide-react';

interface ICreateBreadcrumbsProps {
  onBack?: () => void;
}

export const CreateBreadcrumbs: React.FC<ICreateBreadcrumbsProps> = ({ onBack }) => {
  const history = useHistory();

  const handleBack = (): void => {
    if (onBack) {
      onBack();
    } else {
      history.push('/organizations');
    }
  };

  return (
    <Breadcrumbs
      separator={<ChevronRight size={14} color="#94a3b8" />}
      aria-label="breadcrumb"
      sx={{ mb: 3 }}
    >
      <Link
        component="button"
        variant="body2"
        underline="hover"
        onClick={handleBack}
        sx={{
          color: 'text.secondary',
          fontWeight: 600,
          cursor: 'pointer',
          '&:hover': { color: 'text.primary' },
        }}
      >
        Organizations
      </Link>
      <Typography variant="body2" sx={{ color: 'primary.main', fontWeight: 700 }}>
        Create New
      </Typography>
    </Breadcrumbs>
  );
};
